import { useState } from "react";
import "./App.css";
import CreateToken from "./components/CreateToken/CreateToken";
import TaxContract from "./components/TaxContract/TaxContract";

const App = () => {
  const [formValues, setFormValues] = useState({
    selectContract: "",
    tokenName: "",
    tokenSymbol: "",
    tokenTotalSupply: "",
    router: "Pancakeswap",
    telegram: "",
    website: "",
    liqFee: 0,
    marketingFee: 0,
    liqFee2: 0,
    marketingFee2: 0,
    marketingWallet: "",
    maxTransactionSlider: 1,
    maxWalletAmountSlider: 0.5,
    swapTokensAtAmountSlider: 0.05,
    liquidityProportion: 95,
    nativeLiquid: 0,
    lpLockService: "Pinksale",
    lockedFor: "1 Month",
    openTrade: false,
    antiWhale: false,
    antiBot: false,
    antiBotBlock: false,
  });
  console.log(formValues);
  return (
    <div className="App">
        <CreateToken formValues={formValues} setFormValues={setFormValues} />
        <TaxContract formValues={formValues} setFormValues={setFormValues} />
    </div>
  );
};

export default App;
